import { useState, useEffect } from 'react';
import { dataService } from '../lib/dataService';

export const useData = () => {
  const [data, setData] = useState({
    categories: [],
    items: [],
    pricingConfig: {},
    linenTypes: [],
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch all data
  const fetchAllData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      const result = await dataService.getAllData();
      setData(result);
    } catch (err) {
      console.error('Error fetching data:', err);
      setError(err.message);
      
      // Fallback to mock data if API fails
      const mockData = dataService.getMockData();
      setData(mockData);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch specific data types
  const fetchCategories = async () => {
    try {
      const categories = await dataService.getCategories();
      setData(prev => ({ ...prev, categories }));
      return categories;
    } catch (err) {
      console.error('Error fetching categories:', err);
      throw err;
    }
  };

  const fetchItems = async () => {
    try {
      const items = await dataService.getItems();
      setData(prev => ({ ...prev, items }));
      return items;
    } catch (err) {
      console.error('Error fetching items:', err);
      throw err;
    }
  };

  const fetchPricingConfig = async () => {
    try {
      const pricingConfig = await dataService.getPricingConfig();
      setData(prev => ({ ...prev, pricingConfig }));
      return pricingConfig;
    } catch (err) {
      console.error('Error fetching pricing config:', err);
      throw err;
    }
  };

  const fetchItemsByCategory = async (categoryId) => {
    try {
      const items = await dataService.getItemsByCategory(categoryId);
      return items;
    } catch (err) {
      console.error('Error fetching items by category:', err);
      throw err;
    }
  };

  // Refresh data
  const refreshData = () => {
    dataService.clearCache();
    return fetchAllData();
  };

  // Initialize data on mount
  useEffect(() => {
    fetchAllData();
  }, []);

  return {
    // Data
    categories: data.categories,
    items: data.items,
    pricingConfig: data.pricingConfig,
    linenTypes: data.linenTypes,
    
    // State
    isLoading,
    error,
    
    // Actions
    fetchAllData,
    fetchCategories,
    fetchItems,
    fetchPricingConfig,
    fetchItemsByCategory,
    refreshData,
  };
}; 